import pages from "./de-pages";
import order from "./de-order";
import bank from "./de-bank";

const de = {
  ...pages,
  ...order,
  ...bank,
  "Home": "Startseite",
  "Order": "Bestellen",
  "Private & Events": "Privat & Events",
  "Business": "Unternehmen",
  "Album": "Album",
  "Contact": "Kontakt",
  "Order Your Song": "Deinen Song bestellen",
  "Order a Song": "Song bestellen",
  "Main navigation": "Hauptnavigation",
  "Mobile navigation": "Mobile Navigation",
  "Toggle menu": "Menü öffnen oder schliessen",
  "Select language": "Sprache auswählen",
  "Language": "Sprache",
  "Automatic": "Automatisch",
  "Tailor-made custom songs, radio jingles and album productions — written, recorded and mastered in Switzerland.": "Individuelle Songs, Radio-Jingles und Albumproduktionen — geschrieben, aufgenommen und gemastert in der Schweiz.",
  "Business & Jingles": "Unternehmen & Jingles",
  "Album Production": "Albumproduktion",
  "Legal": "Rechtliches",
  "Privacy Policy": "Datenschutz",
  "Imprint": "Impressum",
  "Switzerland": "Schweiz",
  "© 2026 Evinet.group — Evi-Studio. All rights reserved.": "© 2026 Evinet.group — Evi-Studio. Alle Rechte vorbehalten.",
  "Studio Player": "Studio-Player",
  "Songs produced by Evi-Studio": "Songs aus dem Evi-Studio",
  "Play {{title}}": "{{title}} abspielen",
  "Toggle lyrics for {{title}}": "Songtext für {{title}} ein- oder ausblenden",
  "Seek": "Wiedergabeposition",
  "Previous track": "Vorheriger Titel",
  "Next track": "Nächster Titel",
  "Pause": "Pause",
  "Play": "Abspielen",
  "Unmute": "Ton einschalten",
  "Mute": "Stummschalten",
  "Volume": "Lautstärke",
  "Evi-Studio — Custom Songs, Jingles & Albums": "Evi-Studio — Individuelle Songs, Jingles & Alben",
  "Personal songs, radio jingles and album productions. Your story, professionally produced by Evi-Studio.": "Persönliche Songs, Radio-Jingles und Albumproduktionen. Deine Geschichte, professionell produziert von Evi-Studio.",
};
export default de;